import { PortalId } from '../core/portal';
import { createAdminScene } from './admin.scene';
import { createDashboardScene } from './dashboard.scene';
import { createOperadoresScene } from './operadores.scene';
import { SceneFactory } from './portal-scene';
import { createProveedoresScene } from './proveedores.scene';

export const SCENE_FACTORIES: Readonly<Record<PortalId, SceneFactory>> = {
  admin: createAdminScene,
  dashboard: createDashboardScene,
  operadores: createOperadoresScene,
  proveedores: createProveedoresScene,
};

export { disposeObject3D, type PortalScene, type SceneFactory } from './portal-scene';
